export default {
  install (Vue) {
    // 自定义全局过滤器
    // Vue.filter('filterName', (value) => {
    //
    // })
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js